import Transformer from '../../transformer'

export default class familyTransformer extends Transformer {
  static fetch(family) {
    return {
      id: family.id,
      businessLineId: family.business_line,
      name: family.name,
      codename: family.codename,
      isActive: true,
    }
  }
  
  static send(family) {
    return {
      id: family.id,
      business_line: family.businessLineId,
      name: family.name,
      codename: family.codename,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/supplys/family.js